export const mainUserPlans = [
  {
    id: 'main-3',
    duration: 3,
    price: 90,
    pricePerMonth: 30,
    currency: '₼',
    recommended: false,
    features: {
      az: [
        '3 aylıq istifadə',
        'Plan müddəti ərzində limitsiz fakturalar',
        'Müddət bitdikdən sonra ayda 2 pulsuz faktura',
        'Texniki dəstək',
      ],
      ru: [
        'Использование 3 месяца',
        'Неограниченное количество счетов в течение периода действия плана',
        '2 бесплатных счета в месяц после окончания срока действия',
        'Техническая поддержка',
      ],
      en: [
        '3 months of usage',
        'Unlimited invoices during the plan period',
        '2 free invoices per month after expiration',
        'Technical support',
      ],
    },
  },
  {
    id: 'main-6',
    duration: 6,
    price: 150,
    pricePerMonth: 25,
    currency: '₼',
    recommended: false,
    features: {
      az: [
        '6 aylıq istifadə',
        'Plan müddəti ərzində limitsiz fakturalar',
        'Müddət bitdikdən sonra ayda 2 pulsuz faktura',
        'Texniki dəstək',
      ],
      ru: [
        'Использование 6 месяцев',
        'Неограниченное количество счетов в течение периода действия плана',
        '2 бесплатных счета в месяц после окончания срока действия',
        'Техническая поддержка',
      ],
      en: [
        '6 months of usage',
        'Unlimited invoices during the plan period',
        '2 free invoices per month after expiration',
        'Technical support',
      ],
    },
  },
  {
    id: 'main-12',
    duration: 12,
    price: 240,
    pricePerMonth: 20,
    currency: '₼',
    recommended: true,
    features: {
      az: [
        '12 aylıq istifadə',
        'Plan müddəti ərzində limitsiz fakturalar',
        'Müddət bitdikdən sonra ayda 2 pulsuz faktura',
        'Texniki dəstək',
        'Ən sərfəli qiymət',
      ],
      ru: [
        'Использование 12 месяцев',
        'Неограниченное количество счетов в течение периода действия плана',
        '2 бесплатных счета в месяц после окончания срока действия',
        'Техническая поддержка',
        'Самая выгодная цена',
      ],
      en: [
        '12 months of usage',
        'Unlimited invoices during the plan period',
        '2 free invoices per month after expiration',
        'Technical support',
        'Best value price',
      ],
    },
  },
];

export const subUserPlans = [
  {
    id: 'sub-3',
    duration: 3,
    price: 30,
    currency: '₼',
    recommended: false,
  },
  {
    id: 'sub-6',
    duration: 6,
    price: 50,
    currency: '₼',
    recommended: false,
  },
  {
    id: 'sub-12',
    duration: 12,
    price: 90,
    currency: '₼',
    recommended: true,
  },
];

export const freePlanFeatures = {
  az: [
    'Plan müddəti ərzində limitsiz fakturalar',
    'Müddət bitdikdən sonra ayda 2 pulsuz faktura',
    'Limitsiz istifadəçi əlavə etmə imkanı',
    'Rəqəmsal faktura idarəetməsi',
  ],
  ru: [
    'Неограниченное количество счетов в течение периода действия плана',
    '2 бесплатных счета в месяц после окончания срока действия',
    'Возможность добавления неограниченного количества пользователей',
    'Управление электронными счетами',
  ],
  en: [
    'Unlimited invoices during the plan period',
    '2 free invoices per month after expiration',
    'Ability to add unlimited users',
    'Digital invoice management',
  ],
};
